export const defaultMenuType = 'menu-default';
export const subHiddenBreakpoint = 768;
export const menuHiddenBreakpoint = 368;
export const defaultLocale = 'es';
export const localeOptions = [{ id: 'es', name: 'Español', direction: 'ltr' }, { id: 'en', name: 'English', direction: 'ltr' }];

export const adminRoot = '/app';
export const userRoot = '/user';
//export const verifiedRoot = 'https://test-portal-proveedores/user/verified/';
export const verifiedRoot = 'http://localhost:3000/user/verified/';
export const storagePath = `/destination/file`;


export const searchPath = `${adminRoot}/#`;
//export const servicePath = 'http://localhost:5001/unops-infraigss-prod/us-central1/unit_health/';
export const servicePath = 'https://us-central1-unops-infraigss-prod.cloudfunctions.net/unit_health/'; //Producción
export const currentUser = {
  id: 1,
  title: 'No definido',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
}

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.blueyale';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = ['blueyale'];
